"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var verticalScroll = function verticalScroll(scrolledEl) {
  var elements = scrolledEl.parentElement.parentElement.querySelectorAll('main');
  elements.forEach(function (el) {
    if (el === scrolledEl) return;
    el.scrollTop = scrolledEl.scrollTop;
  });
};

var _default = verticalScroll;
exports.default = _default;